import { clsx } from 'clsx';

import type { AnchorPopupProps } from './types';

interface AtomProps {
  className?: string;
}

type UseAnchorPopupView = (
  props: AnchorPopupProps,
  classes: Record<string, string>,
) => {
  rootProps: AtomProps;
};

export const useAnchorPopupView: UseAnchorPopupView = (
  { enabled, classes: externalClasses },
  classes,
) => {
  const finalClasses = externalClasses || classes;

  return {
    rootProps: {
      className: clsx(finalClasses.root, { [finalClasses.enabled]: enabled }),
    },
  };
};
